class CRMManager {
  static crmUsers = null;

  static setCrmusers = (data) => {
    this.crmUsers = data;
  };
}

export default CRMManager;
